export enum ArticleImagesEnum {
  //Imágenes del artículo - Se usa para las validaciones
  imagen1 = 1,
  imagen2 = 2,
  imagen3 = 3,
}